export const environment = {
  production: false,
  apiUrl: 'https://api-dev-medlab.qomratech.com/api/v1/',
  baseUrl: 'https://api-dev-medlab.qomratech.com/',
  defaultLanguage: 'ar',
  version: '187',
  build: '187',
  updated_at: new Date(Date.now()).toUTCString(),
  firebase: {
    apiKey: 'AIzaSyBB-DzZHphQ2UStktXXb4JclhHLqMe8XC0',
    authDomain: 'medlab-6690d.firebaseapp.com',
    projectId: 'medlab-6690d',
    storageBucket: 'medlab-6690d.firebasestorage.app',
    messagingSenderId: '324624612883',
    appId: '1:324624612883:web:5b4b9c4f8e8ba0685909e6',
    measurementId: 'G-VSGGC20T29',
    vapidKey: 'BFMx4vmeWsj3uzgJoTpQuL_UxS_Lbqi1PM_tUG245M6k-Tz7Kdg_1tjgMEK2sr24hlBwW27IWkLKkacurNXTUHM',
  },
};
